<template>
	<div>
		<TextEditor :entity="form" label="Navn" alias="5ce68ef5d6c2910bb09c58a5" :validate="true" scope="productgroup"></TextEditor>

		<TextEditor :entity="form" label="Nummer" alias="5ce693e7d6c2910bb09c58d8" :validate="false" scope="productgroup"></TextEditor>

		<UserPicker :entity="form" label="Oprettet af" alias="5ce68f0ad6c2910bb09c58a6" :values="$users" :validate="true" scope="productgroup"></UserPicker>
	</div>
</template>

<script>
import UserPicker from "../../_ui/editors/user";
import TextEditor from "../../_ui/editors/text";

export default {
	data: () => ({
		form: {}
	}),
	components: { UserPicker, TextEditor },
	computed: {},
	watch: {},
	props: [],
	methods: {
		ok() {
			this.$validator.validate("productgroup.*").then(valid => {
				if (valid) {
					this.$http.put("/api/module/products/productgroups", this.form).then(x => {
						this.$emit("close");

						this.$router.push("/products/productgroups/" + x.data);
					});
				}
			})
		},
		cancel() {
			this.$emit("close");
		}
	},
	created() {},
	mounted() {},
};
</script>